module.exports = __webpack_public_path__ + "img/img-104.5c110aa4.png";